<script setup lang="ts">
import { computed } from 'vue'

// Code points from Flutter's CupertinoIcons, using the same font as UIG mobile.
const glyphs = {
  arrow_down_to_line: 0xf4fb,
  arrow_down_to_line_alt: 0xf4fc,
  arrow_2_circlepath: 0xf4e3,
  arrow_left: 0xf4fd,
  arrow_right: 0xf50a,
  bolt_circle_fill: 0xf597,
  bolt_fill: 0xf598,
  check_mark: 0xf3fd,
  check_mark_circled_solid: 0xf3ff,
  chevron_down: 0xf5d5,
  chevron_left: 0xf3d2,
  chevron_right: 0xf3d3,
  cloud_upload: 0xf8c6,
  doc_text: 0xf638,
  eye_fill: 0xf425,
  eye_slash_fill: 0xf663,
  film: 0xf66b,
  gauge: 0xf686,
  globe: 0xf68d,
  house_fill: 0xf6ca,
  lock_fill: 0xf4c9,
  person_crop_circle: 0xf419,
  person_fill: 0xf47e,
  photo: 0xf767,
  photo_fill: 0xf768,
  photo_fill_on_rectangle_fill: 0xf769,
  photo_on_rectangle: 0xf76a,
  play_fill: 0xf488,
  play_rectangle: 0xf771,
  play_rectangle_fill: 0xf772,
  plus: 0xf489,
  share: 0xf4ca,
  shield_fill: 0xf7d0,
  sparkles: 0xf7e8,
  star_fill: 0xf822,
  time: 0xf402,
  trash: 0xf4c4,
  video_camera: 0xf4cc,
  wand_stars: 0xf892,
  xmark: 0xf404,
} as const

export type UigIconName = keyof typeof glyphs

const props = withDefaults(defineProps<{
  name: UigIconName
  size?: number
}>(), { size: 20 })

const glyph = computed(() => String.fromCodePoint(glyphs[props.name]))
</script>

<template>
  <span
    class="uig-icon"
    :style="{ fontSize: `${size}px` }"
    aria-hidden="true"
  >{{ glyph }}</span>
</template>
